<div class="bub-add">
  <div class="bub-fields" [class.bub-fields-sales]="isSalesBrick">
    <div class="bub-field">
      <label>{{'businessUnitBricks.BrickLevel' | translate}}</label>
      <span class="ui-fluid">
        <p-dropdown [options]="brickLevels"
                    styleClass="wid100"
                    placeholder="Brick Level"
                    emptyFilterMessage="No results found"
                    (onChange)="onChangeBrickLevel()"
                    name="brickLevelId"
                    [disabled]="fixedLevelId > 0"
                    [(ngModel)]="brickLevel"
                    [filter]="true" optionLabel="name"></p-dropdown>
      </span>
      <small *ngIf="fixedLevelId > 0" class="bub-hint"><i class="fa fa-lock"></i> Set in Settings ({{ isSalesBrick ? 'BusinessUnitSalesBricksLevel' : 'BusinessUnitBricksLevel' }})</small>
    </div>
    <div class="bub-field" [class.has-error]="submitted && !startDate">
      <label>{{'businessUnitBricks.StartDate' | translate}} <span class="bub-req">*</span></label>
      <input type="date" class="form-control" name="startDate" [(ngModel)]="startDate" required />
      <small *ngIf="submitted && !startDate" class="bub-hint text-danger">{{'app.RequiredField' | translate}}</small>
    </div>
    <div class="bub-field">
      <label>{{'businessUnitBricks.EndDate' | translate}}</label>
      <input type="date" class="form-control" name="endDate" [(ngModel)]="endDate" [min]="startDate" />
    </div>
    <div class="bub-field" *ngIf="!isSalesBrick">
      <label>Is Centre</label>
      <label class="switch">
        <input type="checkbox" name="isCentre" [(ngModel)]="isCentre">
        <span class="slider round"></span>
      </label>
    </div>
  </div>

  <div class="bub-picker" *ngIf="brickLevel && brickLevel.id > 0">
    <div class="bub-picker-toolbar">
      <div class="bub-search">
        <i class="fa fa-search"></i>
        <input type="text" name="search" placeholder="Search bricks" autocomplete="off" [(ngModel)]="search" (ngModelChange)="onSearchChange()" />
        <button *ngIf="search" type="button" class="bub-search-clear" title="Clear search" (click)="clearSearch()"><i class="fa fa-times"></i></button>
      </div>
      <div class="bub-picker-tools">
        <button type="button" class="bub-tool" [disabled]="bricks.length == 0" (click)="selectShown()"><i class="fa fa-check-square-o"></i> Select shown</button>
        <button type="button" class="bub-tool" [class.on]="showSelectedOnly" [disabled]="selectedCount == 0" (click)="toggleSelectedOnly()"><i class="fa fa-filter"></i> Selected only</button>
        <button type="button" class="bub-tool" [disabled]="selectedCount == 0" (click)="clearSelection()"><i class="fa fa-square-o"></i> Clear</button>
      </div>
    </div>

    <div class="bub-chips" *ngIf="selectedCount > 0">
      <span class="bub-chips-title">Selected ({{selectedCount}})</span>
      <span class="bub-chip" *ngFor="let brick of selectedBricks">
        {{brick.name}}
        <button type="button" title="Remove" (click)="unselect(brick)"><i class="fa fa-times"></i></button>
      </span>
    </div>

    <div class="bub-add-box">
      <div class="bub-add-list" #brickList (scroll)="onListScroll()">
        <label class="bub-add-item" *ngFor="let brick of (showSelectedOnly ? selectedBricks : bricks)" [class.checked]="brick.selected">
          <input type="checkbox" [(ngModel)]="brick.selected" (ngModelChange)="onToggle(brick)" name="selected_{{brick.id}}">
          <span>{{brick.name}}</span>
        </label>
        <div class="bub-add-empty bub-add-full" *ngIf="!loading && bricks.length == 0">
          <i class="fa fa-inbox"></i>
          <span>{{'app.NoDataFound' | translate}}</span>
        </div>
        <div class="text-muted bub-add-full bub-add-more" *ngIf="showLoading && bricks.length > 0"><i class="fa fa-spinner fa-spin"></i> Loading more…</div>
      </div>
      <div class="bub-add-loading" *ngIf="showLoading && bricks.length == 0"><i class="fa fa-spinner fa-spin"></i> Loading bricks…</div>
    </div>

    <div class="bub-picker-footer">
      <span *ngIf="!showSelectedOnly">Showing {{bricks.length}} of {{totalBricks}} bricks</span>
      <span *ngIf="showSelectedOnly">Showing the selected bricks only</span>
      <button type="button" class="bub-selected-badge" [class.active]="selectedCount > 0" [disabled]="selectedCount == 0"
              title="Show the selected bricks only" (click)="toggleSelectedOnly()">{{selectedCount}} selected</button>
    </div>
  </div>

  <div class="bub-add-actions">
    <span class="text-danger bub-add-error"><span *ngIf="submitted && selectedCount == 0">Choose at least one brick.</span></span>
    <button class="btn btn-cancel" type="button" (click)="cancel()">{{'app.cancel' | translate}}</button>
    <button class="btn btn-save" type="button" [disabled]="displayMode == 1" (click)="save()">
      <i *ngIf="displayMode == 1" class="fa fa-spinner fa-spin"></i> {{'app.save' | translate}}
    </button>
  </div>
</div>
